import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '~spa/Components/Link/Link';
import './styles/message-button-card.scss';

const baseClass = 'bb-message-button-card';

const MessageButtonCard = ({ MessageIconClassName, title, message, button, link }) => {
    const messageIconClass = typeof MessageIconClassName !== 'undefined' ? `${baseClass}__icon ${baseClass}__icon-${MessageIconClassName}` : '';
    const showButton = (typeof button !== 'undefined') && (typeof link !== 'undefined');

    return (
        <div className={baseClass}>
            <div className={`${baseClass}__container`}>
                <div className={messageIconClass}></div>
                <h1 className={`${baseClass}__title`}>
                    {title}
                </h1>
                <p className={`${baseClass}__message`}>
                    {message}
                </p>
                {
                    showButton
                    ? (
                        <Link to={link} className={`${baseClass}__button`} target='_self'>
                            <span>{button}</span>
                        </Link>
                    )
                    : null
                }
            </div>
        </div>
    );
};

MessageButtonCard.propTypes = {
    title: PropTypes.string,
    MessageIconClassName: PropTypes.string,
    button: PropTypes.string,
    link: PropTypes.string,
    message: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.arrayOf(PropTypes.object),
    ]).isRequired,
};

export default MessageButtonCard;
